export const COOKIE_KEYS = {
  USER: "user",
  DOMAIN: "domain",
  BRANCH_IDS: "branch_ids",
};
